import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { FaTelegram } from 'react-icons/fa';

const FloatingChatButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleWhatsApp = () => {
    const whatsappUrl = "https://api.whatsapp.com/send/?phone=9599222655&text=Hello%2C+please+contact+me+regarding+https%3A%2F%2Fmedicallinkers.org%2F+%2C+Thank+you%21&type=phone_number&app_absent=0";
    window.open(whatsappUrl, '_blank');
    setIsOpen(false);
  };

  const handleTelegram = () => {
    const telegramUrl = "https://t.me/medicallinkers";
    window.open(telegramUrl, '_blank');
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Floating Chat Options */}
      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        <div className="flex flex-col space-y-3 mb-4">
          {/* WhatsApp Button */}
          <button
            onClick={handleWhatsApp}
            className="bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg transition-all duration-200 transform hover:scale-110"
            title="Chat on WhatsApp"
          >
            <FaWhatsapp size={24} />
          </button>
          
          {/* Telegram Button */}
          <button
            onClick={handleTelegram}
            className="bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-full shadow-lg transition-all duration-200 transform hover:scale-110"
            title="Chat on Telegram"
          >
            <FaTelegram size={24} />
          </button>
        </div>
      </div>

      {/* Main Chat Button */}
      <button
        onClick={toggleChat}
        className={`bg-white hover:bg-gray-50 p-3 rounded-full shadow-lg transition-all duration-300 transform ${isOpen ? 'rotate-45' : 'rotate-0'} hover:scale-110 border border-gray-200`}
        title="Get Assistance"
      >
        <img 
          src="/images/chatIcon.png" 
          alt="Chat" 
          className="w-8 h-8"
        />
      </button>
    </div>
  );
};

export default FloatingChatButton;
